var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleAngleTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11046",
    d: "M-4.665-6.628 0-10.828l4.666 4.2a.5.5 0 0 0 .707-.037.5.5 0 0 0-.037-.706l-4.972-4.5a.5.5 0 0 0-.67 0l-5.028 4.5a.5.5 0 0 0-.037.706.5.5 0 0 0 .707.037zm5 .756a.5.5 0 0 0-.67 0l-5 4.5a.5.5 0 0 0-.037.706.5.5 0 0 0 .707.037L0-4.828l4.666 4.2a.5.5 0 0 0 .707-.037.5.5 0 0 0-.037-.706l-5-4.5z",
    transform: "translate(10 16)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8616",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleAngleTop);
export default __webpack_public_path__ + "static/media/double-angle-top.d6dbcb55e6fb8a33a5831175bf5f6f4e.svg";
export { ForwardRef as ReactComponent };